/* eslint-disable no-param-reassign */
import * as yup from 'yup'

export function createYupSchema(schema, config) {
  const { id, validationType, validations = [] } = config
  if (!yup[validationType]) {
    return schema
  }
  let validator = yup[validationType]()
  validations.forEach((validation) => {
    const { params, type } = validation
    if (!validator[type]) {
      return
    }
    if (type === 'when') {
      const [field, options] = params
      validator = validator.when(field, ([value], conditionSchema) => {
        if (options.is(value)) {
          return typeof options.then === 'function'
            ? options.then(conditionSchema)
            : conditionSchema.required(options.then.message)
        }
        return conditionSchema
      })
    } else {
      validator = validator[type](...params)
    }
  })
  schema[id] = validator
  return schema
}
